import api from '../utils/axiosConfig';

export const jobService = {
  // Get all jobs for the authenticated user
  getAllJobs: async () => {
    const response = await api.get('/api/jobs');
    return response.data;
  },

  // Get jobs by stage
  getJobsByStage: async (stage) => {
    const response = await api.get(`/api/jobs/stage/${stage}`);
    return response.data;
  },

  // Create a new job
  createJob: async (jobData) => {
    const response = await api.post('/api/jobs', jobData);
    return response.data;
  },

  // Update a job
  updateJob: async (id, jobData) => {
    const response = await api.put(`/api/jobs/${id}`, jobData);
    return response.data;
  },

  // Update job stage specifically (for drag and drop)
  updateJobStage: async (id, stage, sourceIndex = undefined, destinationIndex = undefined) => {
    const payload = { stage };
    if (sourceIndex !== undefined && destinationIndex !== undefined) {
      payload.sourceIndex = sourceIndex;
      payload.destinationIndex = destinationIndex;
    }
    const response = await api.put(`/api/jobs/${id}/stage`, payload);
    return response.data;
  },

  // Delete a job
  deleteJob: async (id) => {
    const response = await api.delete(`/api/jobs/${id}`);
    return response.data;
  },

  // Get job statistics
  getJobStats: async () => {
    const response = await api.get('/api/jobs/stats');
    return response.data;
  }
}; 